// JsFromRoutes CacheKey 746dadd5415eaee51c28d570b03abd13
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client";

export default {
  duplicate: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/rewards/:id/duplicate",
  ),
  toggleApproval: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/rewards/:id/toggle_approval",
  ),
  toggleTag: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/rewards/:id/toggle_tag",
  ),
  createNftCollection: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/rewards/:id/create_nft_collection",
  ),
  fetchPossibleWinnersToSync: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/rewards/:id/fetch_possible_winners_to_sync",
  ),
  syncWinners: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/rewards/:id/sync_winners",
  ),
  index: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/programs/:program_id/rewards",
  ),
  adminV2ParticipantRewards: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/participants/:participant_id/rewards",
  ),
  create: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/programs/:program_id/rewards",
  ),
  createPost: /* #__PURE__ */ definePathHelper(
    "post",
    "/admin/v2/participants/:participant_id/rewards",
  ),
  new: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/programs/:program_id/rewards/new",
  ),
  newAdminV2ParticipantReward: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/participants/:participant_id/rewards/new",
  ),
  edit: /* #__PURE__ */ definePathHelper("get", "/admin/v2/rewards/:id/edit"),
  editGet: /* #__PURE__ */ definePathHelper(
    "get",
    "/admin/v2/rewards/:id/edit",
  ),
  show: /* #__PURE__ */ definePathHelper("get", "/admin/v2/rewards/:id"),
  showGet: /* #__PURE__ */ definePathHelper("get", "/admin/v2/rewards/:id"),
  update: /* #__PURE__ */ definePathHelper("patch", "/admin/v2/rewards/:id"),
  updatePatch: /* #__PURE__ */ definePathHelper(
    "patch",
    "/admin/v2/rewards/:id",
  ),
  destroy: /* #__PURE__ */ definePathHelper("delete", "/admin/v2/rewards/:id"),
  destroyDelete: /* #__PURE__ */ definePathHelper(
    "delete",
    "/admin/v2/rewards/:id",
  ),
};
